import { render, staticRenderFns } from "./FavoritesProducts.vue?vue&type=template&id=0d819115"
import script from "./FavoritesProducts.vue?vue&type=script&lang=js"
export * from "./FavoritesProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports